<template>
  <v-container>
    <div class="elevation-2 px-5 mt-3 hide-on-print">
      <SimplePageHeader title="Commissions Details" class="px-4 pr-5 mb-5">
        <template v-slot:right-buttons>
          <ButtonPrint
            :block="true"
          />
        </template>
      </SimplePageHeader>
      <CommissionDetailsReportFilters
        ref="filters"
        class="px-5 mb-sm-5"
        :readonly="isReadOnlyAccess"
        @search="handleSearch"
        @clear="handleSearch"
      ></CommissionDetailsReportFilters>
    </div>
    <ReportHeader
      reportTitle="Commission Details Report"
      :reportCriteria="reportFilterCriteria"
    ></ReportHeader>
    <div v-if="!showNoDataMessage" class="mt-5">
      <v-row v-if="employeeName">
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <CommissionDetailsReportHeader
                :userName="employeeName"
                :commissionAmount="totalCommission"
                :individualGp="totalIndividualGP"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="directPlacementGrossProfitItems && directPlacementGrossProfitItems.length > 0">
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <DirectPlacementCommissions
                class="px-4 pt-5"
                :directPlacementCommissions="directPlacementGrossProfitItems"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="assignmentGrossProfitItems && assignmentGrossProfitItems.length > 0">
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <AssignmentsGrossProfits
                class="px-4 pt-5"
                :assignmentGrossProfitItems="assignmentGrossProfitItems"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="teamMembersGrossProfitItems && teamMembersGrossProfitItems.length > 0">
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <TeamMembersGrossProfitTable
                class="px-4 pt-5"
                :commissionOverridePercentage="commissionOverridePercentage"
                :teamMemberGrossProfitItems="teamMembersGrossProfitItems"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="commissionTiers && commissionTiers.length > 0">
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <CommissionTiers
                class="px-4 pt-5"
                :commissionTiers="commissionTiers"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div class="mt-5" v-if="showNoDataMessage">
      <NoDataAvailableMessage></NoDataAvailableMessage>
    </div>
    <BottomSpacer></BottomSpacer>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import CommissionDetailsReportFilters from './CommissionDetailsReportFilters'
import { ButtonPrint, BottomSpacer } from '@/components/buttons'
import CommissionDetailsReportHeader from './CommissionDetailsReportHeader'
import DirectPlacementCommissions from './DirectPlacementCommissions'
import AssignmentsGrossProfits from './AssignmentsGrossProfits'
import CommissionTiers from './CommissionTiers'
import { SimplePageHeader } from '@/components/pageComponents'
import { ADMIN, MANAGER } from '@/lib/constants/securityRoles'
import { getCurrentUser, userHasRoles } from '@/lib/authentication'
import { NoDataAvailableMessage } from '@/components/reports'
import TeamMembersGrossProfitTable from './TeamMemberGrossProfitTable'
import ReportHeader from '@/components/reports/ReportHeader'

export default {
  components: {
    CommissionDetailsReportFilters,
    ButtonPrint,
    BottomSpacer,
    CommissionDetailsReportHeader,
    DirectPlacementCommissions,
    AssignmentsGrossProfits,
    CommissionTiers,
    SimplePageHeader,
    NoDataAvailableMessage,
    TeamMembersGrossProfitTable,
    ReportHeader
  },
  data () {
    return {
      showNoDataMessage: true
    }
  },
  computed: {
    ...mapFields('commissionDetailsReport', [
      'employeeName',
      'assignmentGrossProfitItems',
      'directPlacementGrossProfitItems',
      'teamMembersGrossProfitItems',
      'commissionTiers',
      'consultantsGP',
      'permPlacementGP',
      'totalIndividualGP',
      'commissionOverride',
      'commissionOverridePercentage',
      'totalCommission'
    ]),
    ...mapFields('commissionDetailsReportFilters', [
      'userId',
      'month',
      'year'
    ]),
    reportFilterCriteria: {
      get () {
        let months = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ]
        return [
          { 'key': 'Month', 'value': months[parseInt(this.month) - 1] + ' - ' + parseInt(this.year) }
        ]
      }
    },
    userIdURLParameter () {
      return this.$route.query.user
    },
    yearURLParameter () {
      return this.$route.query.year
    },
    monthURLParameter () {
      return this.$route.query.month
    },
    isReadOnlyAccess () {
      return !this.userHasRoles({ user: this.getCurrentUser(), allowedRoles: [ADMIN, MANAGER] })
    }
  },
  methods: {
    userHasRoles,
    getCurrentUser,
    ...mapActions('commissionDetailsReport', [
      'getCommissionDetailsReportWithFilters'
    ]),
    handleSearch () {
      this.getCommissionDetailsReportWithFilters().then(() => {
        if (this.userId) {
          this.showNoDataMessage = !this.employeeName
        } else {
          this.showNoDataMessage = true
        }
      })
    }
  },
  mounted () {
    if (this.isReadOnlyAccess) {
      this.userId = getCurrentUser().id
      this.handleSearch()
    } else if (this.userIdURLParameter && this.yearURLParameter && this.monthURLParameter) {
      this.userId = parseInt(this.userIdURLParameter)
      this.year = this.yearURLParameter
      this.month = this.monthURLParameter
      this.handleSearch()
    }
  }
}
</script>
